module.exports = __webpack_public_path__ + "img/video_icon.1fbef496.svg";